import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { startCase } from 'lodash';

class SearchField extends Component {
  render() {
    const { handleInputChange, searchOption, value } = this.props;

    return (
      <Form.Field>
        <Form.Input
          aria-label={`Search by ${startCase(searchOption)}`}
          name={searchOption}
          placeholder={`Search by ${startCase(searchOption)}`}
          value={value}
          onChange={handleInputChange}
        />
      </Form.Field>
    );
  }
}

SearchField.propTypes = {
  handleInputChange: PropTypes.func,
  searchOption: PropTypes.string,
  value: PropTypes.string,
};

export default SearchField;
